import { TOAST_ERROR_RESET, TOAST_ERROR_RETURN } from "../constants/toastError";

export function redirectAndReloadPageOld() {
  const isAlreadyCrashed = localStorage.getItem('isAlreadyCrashed');

  if (isAlreadyCrashed) {
    localStorage.setItem('showToastPikko', TOAST_ERROR_RESET);
    localStorage.removeItem('isAlreadyCrashed');

    location.href = '/home';
    setTimeout(() => {
      location.reload()
    }, 250)
  }
  else {
    localStorage.setItem('isAlreadyCrashed', 'true');
    localStorage.setItem('showToastPikko', TOAST_ERROR_RETURN);
    location.reload();
  }
}

export function redirectAndReloadPage() {
  localStorage.setItem('showToastPikko', TOAST_ERROR_RESET);

  location.href = '/home';
  setTimeout(() => {
    location.reload()
  }, 250)
}
